import { useState } from 'react';
import firebase from 'firebase/compat/app';
import { formatTimestampDDMMYYYYHHMM } from '../../utils/dateHelpers';

const functions = firebase.functions();

/**
 * Modal for resolving issues on completed-with-issues tasks
 */
export function ResolveIssuesModal({ task, onClose, onSuccess }) {
  const [resolutionNote, setResolutionNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const incompleteSteps = task.steps ? task.steps.filter(s => !s.completed) : [];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!resolutionNote.trim()) {
      setError('Bitte geben Sie eine Auflösungsnotiz ein');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const resolveTaskIssues = functions.httpsCallable('resolveTaskIssues');
      await resolveTaskIssues({
        taskId: task.id,
        resolutionNote: resolutionNote.trim()
      });

      alert('Aufgabe erfolgreich als aufgelöst markiert');
      onSuccess();
    } catch (err) {
      // console statement removed for production
      setError(err.message || 'Fehler beim Auflösen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Probleme auflösen</h2>
          <button className="modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="resolve-issues-content">
          <div className="task-info">
            <h3>{task.title}</h3>
            <p>Abgeschlossen am: {formatTimestampDDMMYYYYHHMM(task.completedAt)}</p>
          </div>

          {incompleteSteps.length > 0 && (
            <div className="incomplete-steps">
              <h4>Nicht abgeschlossene Schritte:</h4>
              <ul>
                {incompleteSteps.map(step => (
                  <li key={step.id}>
                    <i className="fas fa-times"></i> {step.text}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {task.photoComment && (
            <div className="original-comment">
              <h4>Ursprünglicher Kommentar:</h4>
              <p>{task.photoComment}</p>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Auflösungsnotiz * (was wurde unternommen?)</label>
              <textarea
                value={resolutionNote}
                onChange={(e) => setResolutionNote(e.target.value)}
                placeholder="Beschreiben Sie, wie die Probleme gelöst wurden..."
                rows={4}
                maxLength={500}
                required
              />
              <span className="char-counter">{resolutionNote.length}/500</span>
            </div>

            {error && (
              <div className="error-message">{error}</div>
            )}

            <div className="modal-actions">
              <button type="button" onClick={onClose} disabled={loading}>
                Abbrechen
              </button>
              <button type="submit" disabled={loading} className="btn-primary">
                {loading ? 'Speichert...' : 'Als aufgelöst markieren'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
